export const headers = [
  'ID',
  'Город',
];
export const fieldsToSearchCities = [
  'id',
  'name',
];